import styled from 'styled-components';

const SGameTaskWrapper = styled.div`
  color: var(--color-white);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
`;

export default SGameTaskWrapper;
